import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LicenseFeatureService } from '../services/license-feature.service';
import { NotificationService } from 'mnm-webapp';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class FeatureGuard {
    public constructor(
        private readonly licenseFeatureService: LicenseFeatureService,
        private readonly router: Router,
        private readonly notificationService: NotificationService,
        private readonly translateService: TranslateService
    ) {}

    public canActivate(
        activatedRoute: ActivatedRouteSnapshot,
        _: RouterStateSnapshot
    ): boolean {
        return this.canActivateHandler(activatedRoute);
    }

    public canActivateChild(
        activatedRoute: ActivatedRouteSnapshot,
        _: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.canActivateHandler(activatedRoute);
    }

    private canActivateHandler(
        activatedRoute: ActivatedRouteSnapshot
    ): boolean {
        const { featureIds } = activatedRoute.data;

        if (!featureIds || featureIds.length === 0) return true;

        const hasFeature = this.licenseFeatureService.canAccessRoute(
            featureIds as string[]
        );

        if (!hasFeature) {
            this.router.navigate(['']).then();

            this.translateService
                .get(
                    'translate_this_feature_is_not_available_in_your_current_license'
                )
                .subscribe(str => {
                    this.notificationService.notifyError(str);
                });
        }

        return hasFeature;
    }
}
